import React from 'react';
import PropTypes from 'prop-types';

// ICON IS A REUSEABLE COMPONENT THAT REQUIRES SOME MODIFICATIONS IF YOU ARE GOING TO USE IT

const Icon = (props) => (
    <i
        className={`${props.brand ? 'fab' : 'fas'} fa-${props.icon} ${props.options}`}
        onClick={props.onClickHandler ? props.onClickHandler : null}
        onKeyPress={props.onKeyPress ? props.onKeyPress : null}
        tabIndex={props.tabIndex ? props.tabIndex : null}
        aria-label={props.ariaLabel ? props.ariaLabel : null}
        role={props.role ? props.role : null}
        aria-hidden={props.ariaHidden ? props.ariaHidden : null}
        aria-expanded={props.ariaExpanded}
    >
        {props.unread > 0 ? (
            <span className="unread">{props.unread}</span>
        ) : null}
    </i>
)

Icon.propTypes = {
    icon: PropTypes.string.isRequired,
    options: PropTypes.string,
    brand: PropTypes.bool,
    onClickHandler: PropTypes.func,
    onKeyPress: PropTypes.func
}

Icon.defaultProps = {
    brand: false,
    unread: 0,
    tabIndex: false,
    ariaLabel: false,
    role: false,
    ariaHidden: true,
    options: ''
}


export default Icon



// WEBPACK FOOTER //
// ./src/components/Icon/index.js